import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    // Parse hash: #session_id=xxx&...
    const hash = (loc.hash || "").replace(/^#/, "");
    const params = new URLSearchParams(hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    // Role preference set before redirect (customer/assistant)
    const role = localStorage.getItem("hm_google_role") || "customer";

    axios
      .post(`${API}/auth/google/session`, { session_id: sessionId, role }, { withCredentials: true })
      .then((r) => {
        localStorage.setItem("hastaan_token", r.data.token);
        localStorage.removeItem("hm_google_role");
        // Clear hash from URL so it doesn't re-trigger
        window.history.replaceState({}, "", window.location.pathname);
        toast.success(`Welcome, ${r.data.user.name}`);
        // Force reload so AuthProvider picks up the fresh token
        window.location.replace(role === "assistant" ? "/become-mate" : "/dashboard");
      })
      .catch((e) => {
        toast.error(e?.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-[70vh] grid place-items-center">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-4 border-neutral-200 border-t-[color:var(--primary)] animate-spin mx-auto" />
        <p className="mt-4 text-sm text-neutral-500">Signing you in with Google…</p>
      </div>
    </div>
  );
}
